import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgArrowMiniDown32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" d="M10.646 13.043a.5.5 0 0 0 0 .707L16 19.104l5.354-5.354a.5.5 0 0 0-.708-.707L16 17.689l-4.646-4.646a.5.5 0 0 0-.708 0" /></SvgIcon>;
};
const Memo = memo(SvgArrowMiniDown32);
export default Memo;